import styled from 'styled-components';
import { FormPicker } from 'view/common/form-picker';
import { CategoryList } from 'view/common/category-list';
import { PaperContent } from 'view/layout/paper';
import { token } from '@atlaskit/tokens';

export const AnnouncementInnerContainer = styled(PaperContent)`
    /* Reset top padding from the paper content. */
    padding-top: 0;
`;

export const StyledFormPicker = styled(FormPicker)`
    margin: ${token('space.400', '32px')} 0 ${token('space.100', '8px')};
    position: relative;
`;

export const StyledCategoryList = styled(CategoryList)`
    margin-top: ${token('space.400', '32px')};
`;

export const ExternalLinksListWrapper = styled.div`
    margin-top: ${token('space.400', '32px')};
`;

export const AdvertiseUnifiedHelpPortalWrapper = styled.div`
    margin-left: ${token('space.300', '24px')};
    margin-right: ${token('space.300', '24px')};
`;
